
const Menu = [
    {
        code: '1', title: 'Dashboard', icon: 'chart-pie', path: "/dashboard/informational",
        submenu: []
    },
    {
        code: '2', title: 'Operations', icon: 'window-restore', path: "operation",
        submenu: [
            { code: 1, title: 'Budget CIF', path: "/operation/budget_cif" },
            { code: 2, title: 'Actual CIF', path: "/operation/actual_cif" },
            // { code: 4, title: 'Trigger Quantity', path: "/operation/trigger" },
            // { code: 3, title: 'Actual Inflow', path: "/operation/inflow" },
            { code: 5, title: 'Selling Window', path: "/operation/sell_window" },
            { code: 6, title: 'Pricing Window', path: "/operation/price_window" },
            { code: 7, title: 'Daily/Spot Platts', path: "/operation/daily_platts" }
        ]
    },
    {
        code: '5', title: 'Approvals', icon: 'check', path: "approvals",
        submenu: [
            { code: 1, title: 'Pending Cargos', path: "/approvals/cargo" },
            { code: 3, title: 'Approved Cargos', path: "/approvals/approved_cargo" },
            { code: 2, title: 'Under Priced', path: "/approvals/hedge" },
            { code: 4, title: 'Pending Triggers', path: "/approvals/trigger" },
        ]
    },
    {
        code: '3', title: 'Reports', icon: 'layer-group', path: "report",
        submenu: [
            { code: 1, title: 'Audit Trails', path: "/report/audit_trail" },
            { code: 2, title: 'Budget Cargos', path: "/report/budget_cargo_report" },
            { code: 3, title: 'Actual Cargos', path: "/report/actual_cargo_report" },
            { code: 4, title: 'Sales', path: "/report/sales_report" },
            
        ]
    },
    {
        code: '4', title: 'Settings', icon: 'wrench', path: "setting",
        submenu: [
            { code: 1, title: 'Company', path: "/setting/company" },
            { code: 2, title: 'Users', path: "/setting/role" },
            { code: 3, title: 'Products', path: "/setting/product" },
            { code: 4, title: 'Costs', path: "/setting/cost" },
            { code: 5, title: 'Holidays', path: "/setting/holiday" }
        ]
    },
];

export default Menu;